export default __webpack_public_path__ + "static/media/tab-replied-blue.16b531d8.svg";